export var FieldPrefixes = {
    Modifier: {
        Name: 'ModifierName',
        Type: 'ModifierType',
        Description: 'ModifierDescription',
        CharLimit: 'ModifierCharLimit',
        Mandatory: 'ModifierMandatory',
    },
    Option: {
        Name: 'OptionName',
        Type: 'OptionType',
        Choices: 'OptionChoices',
    },
};
export var ExportImportCsvColumnNames;
(function (ExportImportCsvColumnNames) {
    ExportImportCsvColumnNames["Handle"] = "handle";
    ExportImportCsvColumnNames["ProductName"] = "name";
    ExportImportCsvColumnNames["Visible"] = "visible";
    ExportImportCsvColumnNames["ProductDescription"] = "plainDescription";
    ExportImportCsvColumnNames["Media"] = "media";
    ExportImportCsvColumnNames["MediaAltText"] = "mediaAltText";
    ExportImportCsvColumnNames["CompareAtPrice"] = "strikethroughPrice";
    ExportImportCsvColumnNames["ActualPrice"] = "price";
    ExportImportCsvColumnNames["Sku"] = "sku";
    ExportImportCsvColumnNames["Inventory"] = "inventory";
    ExportImportCsvColumnNames["Brand"] = "brand";
    ExportImportCsvColumnNames["Ribbon"] = "ribbon";
    ExportImportCsvColumnNames["CostOfGoods"] = "cost";
    ExportImportCsvColumnNames["ShippingWeight"] = "weight";
    ExportImportCsvColumnNames["ItemType"] = "fieldType";
    ExportImportCsvColumnNames["Barcode"] = "barcode";
    ExportImportCsvColumnNames["PricePerUnitBaseQuantity"] = "baseUnit";
    ExportImportCsvColumnNames["PricePerUnitBaseMeasurementUnit"] = "baseUnitMeasurement";
    ExportImportCsvColumnNames["PricePerUnitTotalQuantity"] = "totalUnits";
    ExportImportCsvColumnNames["PricePerUnitTotalMeasurementUnit"] = "totalUnitsMeasurement";
    ExportImportCsvColumnNames["PreOrderEnabled"] = "preOrderEnabled";
    ExportImportCsvColumnNames["PreOrderMessage"] = "preOrderMessage";
    ExportImportCsvColumnNames["PreOrderLimit"] = "preOrderLimit";
    ExportImportCsvColumnNames["OptionName1"] = "productOptionName1";
    ExportImportCsvColumnNames["OptionType1"] = "productOptionType1";
    ExportImportCsvColumnNames["OptionChoices1"] = "productOptionChoices1";
    ExportImportCsvColumnNames["OptionName2"] = "productOptionName2";
    ExportImportCsvColumnNames["OptionType2"] = "productOptionType2";
    ExportImportCsvColumnNames["OptionChoices2"] = "productOptionChoices2";
    ExportImportCsvColumnNames["OptionName3"] = "productOptionName3";
    ExportImportCsvColumnNames["OptionType3"] = "productOptionType3";
    ExportImportCsvColumnNames["OptionChoices3"] = "productOptionChoices3";
    ExportImportCsvColumnNames["OptionName4"] = "productOptionName4";
    ExportImportCsvColumnNames["OptionType4"] = "productOptionType4";
    ExportImportCsvColumnNames["OptionChoices4"] = "productOptionChoices4";
    ExportImportCsvColumnNames["OptionName5"] = "productOptionName5";
    ExportImportCsvColumnNames["OptionType5"] = "productOptionType5";
    ExportImportCsvColumnNames["OptionChoices5"] = "productOptionChoices5";
    ExportImportCsvColumnNames["OptionName6"] = "productOptionName6";
    ExportImportCsvColumnNames["OptionType6"] = "productOptionType6";
    ExportImportCsvColumnNames["OptionChoices6"] = "productOptionChoices6";
    ExportImportCsvColumnNames["ModifierName1"] = "modifierName1";
    ExportImportCsvColumnNames["ModifierType1"] = "modifierType1";
    ExportImportCsvColumnNames["ModifierDescription1"] = "modifierDescription1";
    ExportImportCsvColumnNames["ModifierCharLimit1"] = "modifierCharLimit1";
    ExportImportCsvColumnNames["ModifierMandatory1"] = "modifierMandatory1";
    ExportImportCsvColumnNames["ModifierName2"] = "modifierName2";
    ExportImportCsvColumnNames["ModifierType2"] = "modifierType2";
    ExportImportCsvColumnNames["ModifierDescription2"] = "modifierDescription2";
    ExportImportCsvColumnNames["ModifierCharLimit2"] = "modifierCharLimit2";
    ExportImportCsvColumnNames["ModifierMandatory2"] = "modifierMandatory2";
    ExportImportCsvColumnNames["ModifierName3"] = "modifierName3";
    ExportImportCsvColumnNames["ModifierType3"] = "modifierType3";
    ExportImportCsvColumnNames["ModifierDescription3"] = "modifierDescription3";
    ExportImportCsvColumnNames["ModifierCharLimit3"] = "modifierCharLimit3";
    ExportImportCsvColumnNames["ModifierMandatory3"] = "modifierMandatory3";
    ExportImportCsvColumnNames["ModifierName4"] = "modifierName4";
    ExportImportCsvColumnNames["ModifierType4"] = "modifierType4";
    ExportImportCsvColumnNames["ModifierDescription4"] = "modifierDescription4";
    ExportImportCsvColumnNames["ModifierCharLimit4"] = "modifierCharLimit4";
    ExportImportCsvColumnNames["ModifierMandatory4"] = "modifierMandatory4";
    ExportImportCsvColumnNames["ModifierName5"] = "modifierName5";
    ExportImportCsvColumnNames["ModifierType5"] = "modifierType5";
    ExportImportCsvColumnNames["ModifierDescription5"] = "modifierDescription5";
    ExportImportCsvColumnNames["ModifierCharLimit5"] = "modifierCharLimit5";
    ExportImportCsvColumnNames["ModifierMandatory5"] = "modifierMandatory5";
    ExportImportCsvColumnNames["ModifierName6"] = "modifierName6";
    ExportImportCsvColumnNames["ModifierType6"] = "modifierType6";
    ExportImportCsvColumnNames["ModifierDescription6"] = "modifierDescription6";
    ExportImportCsvColumnNames["ModifierCharLimit6"] = "modifierCharLimit6";
    ExportImportCsvColumnNames["ModifierMandatory6"] = "modifierMandatory6";
    ExportImportCsvColumnNames["ModifierName7"] = "modifierName7";
    ExportImportCsvColumnNames["ModifierType7"] = "modifierType7";
    ExportImportCsvColumnNames["ModifierDescription7"] = "modifierDescription7";
    ExportImportCsvColumnNames["ModifierCharLimit7"] = "modifierCharLimit7";
    ExportImportCsvColumnNames["ModifierMandatory7"] = "modifierMandatory7";
    ExportImportCsvColumnNames["ModifierName8"] = "modifierName8";
    ExportImportCsvColumnNames["ModifierType8"] = "modifierType8";
    ExportImportCsvColumnNames["ModifierDescription8"] = "modifierDescription8";
    ExportImportCsvColumnNames["ModifierCharLimit8"] = "modifierCharLimit8";
    ExportImportCsvColumnNames["ModifierMandatory8"] = "modifierMandatory8";
    ExportImportCsvColumnNames["ModifierName9"] = "modifierName9";
    ExportImportCsvColumnNames["ModifierType9"] = "modifierType9";
    ExportImportCsvColumnNames["ModifierDescription9"] = "modifierDescription9";
    ExportImportCsvColumnNames["ModifierCharLimit9"] = "modifierCharLimit9";
    ExportImportCsvColumnNames["ModifierMandatory9"] = "modifierMandatory9";
    ExportImportCsvColumnNames["ModifierName10"] = "modifierName10";
    ExportImportCsvColumnNames["ModifierType10"] = "modifierType10";
    ExportImportCsvColumnNames["ModifierDescription10"] = "modifierDescription10";
    ExportImportCsvColumnNames["ModifierCharLimit10"] = "modifierCharLimit10";
    ExportImportCsvColumnNames["ModifierMandatory10"] = "modifierMandatory10";
})(ExportImportCsvColumnNames || (ExportImportCsvColumnNames = {}));
//# sourceMappingURL=constants.js.map